import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HistoricoImportacoesService {

  constructor(private readonly http: HttpClient) { }

  getDadosEmpresa(idEmpresaLogada: string) {
    const url: string = `/apiconnect/importation/company/data/${idEmpresaLogada}/companies`;

    return this.http.get(url);
  }

  getImportacoes(idEmpresa: any, pagina: any, tamanho: any, dataInicial: any, dataFinal: any) {
    let dataInicio: any;
    let dataFim: any;

    if (dataInicial) {
      let data: any = dataInicial.toISOString().substring(0, 10).split('-');
      data = `${data[2]}/${data[1]}/${data[0]}`;
      dataInicio = `&initialDate=${data}`;
    } else {
      const dataInicioPadrao = new Date();
      dataInicioPadrao.setDate(dataInicioPadrao.getDate()-90);
      let data: any = dataInicioPadrao.toISOString().substring(0, 10).split('-');
      data = `${data[2]}/${data[1]}/${data[0]}`;
      dataInicio = `&initialDate=${data}`;
    }

    if (dataFinal) {
      let data: any = dataFinal.toISOString().substring(0, 10).split('-');
      data = `${data[2]}/${data[1]}/${data[0]}`;
      dataFim = `&finalDate=${data}`;
    } else {
      const dataFimPadrao = new Date();
      let data: any = dataFimPadrao.toISOString().substring(0, 10).split('-');
      data = `${data[2]}/${data[1]}/${data[0]}`;
      dataFim = `&finalDate=${data}`;
    }

    const url: string = `/apiconnect/orders/import/history/${idEmpresa}/companies?page=${pagina}&size=${tamanho}${dataInicio}${dataFim}`;

    return this.http.get(url);
  }

  downloadImportacao(idEmpresa: any, idImportacao: any){
    const url: string = `/apiconnect/orders/import-file/companies/${idEmpresa}/importations/${idImportacao}`

    return this.http.get(url, {
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }
}
